import React from "react";
import { cn } from "../../utils/cn";
import type { Plan } from "../../data/landingData";

function SectionHeading({
    eyebrow,
    title,
    subtitle,
}: {
    eyebrow?: string;
    title: string;
    subtitle?: string;
}) {
    return (
        <div className="mx-auto mb-10 max-w-3xl text-center">
            {eyebrow ? (
                <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                    <span className="h-2 w-2 rounded-full bg-white/60" />
                    {eyebrow}
                </div>
            ) : null}
            <h2 className="text-balance text-2xl font-semibold tracking-tight text-white sm:text-3xl">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-3 text-pretty text-sm text-white/70 sm:text-base">{subtitle}</p>
            ) : null}
        </div>
    );
}

export default function Pricing({ plans }: { plans: Plan[] }) {
    return (
        <section id="cennik" className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
            <SectionHeading
                eyebrow="Cennik"
                title="Wybierz plan dla siebie"
                subtitle="Możesz zmienić plan w dowolnym momencie."
            />

            <div className="grid gap-4 lg:grid-cols-3">
                {plans.map((p) => (
                    <div
                        key={p.name}
                        className={cn(
                            "rounded-3xl border backdrop-blur p-6",
                            p.highlight
                                ? "border-white/20 bg-white/10"
                                : "border-white/10 bg-white/5"
                        )}
                    >
                        <div className="flex items-center justify-between">
                            <div className="text-sm font-semibold text-white">{p.name}</div>
                            {p.highlight ? (
                                <span className="rounded-full bg-white px-2 py-1 text-xs font-medium text-black">
                                    Polecany
                                </span>
                            ) : null}
                        </div>

                        <div className="mt-4 flex items-end gap-2">
                            <div className="text-3xl font-semibold text-white">{p.price}</div>
                            {p.period ? <div className="text-sm text-white/60">{p.period}</div> : null}
                        </div>

                        <p className="mt-3 text-sm text-white/70">{p.desc}</p>

                        <ul className="mt-5 space-y-2 text-sm text-white/70">
                            {p.features.map((f) => (
                                <li key={f} className="flex gap-2">
                                    <span className="text-white/40">✓</span>
                                    <span>{f}</span>
                                </li>
                            ))}
                        </ul>

                        <a
                            href={p.ctaHref}
                            className={cn(
                                "mt-6 block rounded-2xl px-4 py-3 text-center text-sm font-medium transition",
                                p.highlight
                                    ? "bg-white text-black hover:bg-white/90"
                                    : "border border-white/10 bg-white/5 text-white/80 hover:bg-white/10"
                            )}
                        >
                            {p.ctaLabel}
                        </a>
                    </div>
                ))}
            </div>
        </section>
    );
}
